export const MODULE_NAME = 'project';
export { default as store } from './project.store';
